import { REPORTSUMMARYPROJECTS_SUCCESS, REPORTSUMMARYPROJECTS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const reportSummaryProjectsReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORTSUMMARYPROJECTS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case REPORTSUMMARYPROJECTS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default reportSummaryProjectsReducer;
